import { useEffect } from "react";

function useClickOutside(ref, onClickEvent) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if (onClickEvent)
                    onClickEvent();
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [ref, onClickEvent]);
}

export default useClickOutside;